var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "previous",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.583,
    height: 29.583,
    viewBox: "0 0 29.583 29.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10383",
    "data-name": "Group 10383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13330",
    "data-name": "Path 13330",
    d: "M14.792,0A14.792,14.792,0,1,0,29.583,14.792,14.808,14.808,0,0,0,14.792,0Zm3.337,20.083a1.232,1.232,0,1,1-1.743,1.743l-6.163-6.163a1.231,1.231,0,0,1,0-1.743l6.163-6.163A1.232,1.232,0,0,1,18.128,9.5l-5.292,5.292Z",
    fill: " #565553"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.4852e6e80f189157e12d0103a05bd7a0.svg";
export { ForwardRef as ReactComponent };